import React, { forwardRef } from 'react';
import { Link as RouterLink, LinkProps as RouteLinkProps} from 'react-router-dom';
import { useGame } from '@domain/game.selection/game.selection.hook';

interface LinkProps extends RouteLinkProps {
  avoidPrefix?: boolean;
}

// A game-aware Link (from react-router-dom) that appends the needed prefix in the passed url
export const Link = forwardRef<any, LinkProps>(({ to, avoidPrefix, ...rest }: LinkProps, ref) => {
  const game = useGame();

  return <RouterLink ref={ref} to={avoidPrefix ? to : `/${game.urlId}${to}`} {...rest} />;
});
